export const TOP_RIGHT = 'top-right';
export const SUCCESS = 'success';
export const ERROR = 'error';
export const WARNING = 'warning';
export const INFO = 'info';
export const EMAIL = 'email';
export const DOCUMENT = 'document';
export const SMS = 'sms';
export const DEFAULT_ERROR_MESSAGE =
  'An error occured. Please reload the page to try again.';
export const EMPTY_VALUE = '--/--';
export const FALL_BACK_TZ = 'Africa/Lagos';
export const MIN_NUMBER_STEPS = 4;
export const LIGHT_ASH = '#f5f5f7';
export const DEEP_BLUE = '#0E405C';
export const PURPLE = '#825efb';
export const SKY_BLUE = '#2EA0D4';
export const MAX_ADDITIONAL_LOCATIONS = 5;

export const PAGE_SIZES = [
  { label: '10 Rows', value: 10 },
  { label: '20 Rows', value: 20 },
  { label: '50 Rows', value: 50 },
  { label: '100 Rows', value: 100 },
];

export const accountTypes = [
  { label: 'Individual', value: 'INDIVIDUAL' },
  { label: 'Company', value: 'COMPANY' },
];

export const currencyCode = [
  { label: 'United States Dollar', value: 'USD' },
  { label: 'Pound Sterling', value: 'GBP' },
  { label: 'Euro', value: 'EUR' },
];

export const currency = [
  { label: 'USD', value: '$' },
  { label: 'GBP', value: '£' },
  { label: 'EUR', value: '€' }
];

export const currencyTags = {
  'USD': '$',
  'GBP': '£',
  'EUR': '€',
  'NGN': '₦',
}

export const alternateCurrencyTags = {
  'USD': '$',
  'GBP': '£',
  'EUR': '€',
  'NGN': 'N',
}

export const bussinessTypes = [
  { label: 'Individual', value: 'INDIVIDUAL' },
  { label: 'Company', value: 'COMPANY' },
  { label: 'Non Porfit', value: 'NON_PROFIT' },
  { label: 'Government Entity', value: 'GOVERNMENT_ENTITY' },
];

export const statusCodes = {
  INTERNAL_SERVER_ERROR: 500,
  BAD_REQUEST: 400,
  CONFLICT: 409,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  POOR_INTERNET: 600,
};

export const HIERARCHICAL_GROUP = 'Organisation Structure';
export const HIERARCHICAL_GROUP_SHORT = 'Org Structure';
